import _ from 'lodash';
import {customTermFilter} from "../../../vue/filters/CustomTerm";
import { GoalFactory, GOAL_CREATION_CANCELLED } from '~/angular/app/projects/goal_settings_factory/goalFactory';
import notifications from '~/vue/plugins/notifications';
import { selectFactory } from '~/angular/app/shared/select_factory/select_factory';
import GoalTaskResource from '~/angular/app/projects/project_task_resource';
import { goalTaskFactory } from '~/angular/app/projects/GoalDetailPage/goal_tasks/goal_task_options/goal_task_factory';
import { createDeferred } from 'shared/utils/deferred';

// the popups call each other back and recurse, so the arguments of the current
// link_to_goal() call are kept here instead of being threaded through every step
let RESOURCE, ENTRY_ID;
let task_id_list_deferred;
let ALLOW_CREATE_GOAL;
let RETURN_OBJECT;

function show_goals_tasks_lists(goal_id, auto_create = false) {

    function create_task(goal_id) {
        goalTaskFactory.show_create_goal_task_wizard(goal_id, undefined, undefined, true)
            .then(res => {
                GoalTaskResource().create_task(goal_id, res)
                    .then(success => {
                        show_goals_tasks_lists(goal_id);
                    }, err => {
                        notifications.error(err || 'Error');
                    });
            }, cancel => {
                show_goals_tasks_lists(goal_id);
            });
    }

    if (auto_create) {
        create_task(goal_id);
        return;
    }

    let select_task_def = selectFactory.endpoint_selector(
        _.partial(RESOURCE.get_users_tasks_for_link_in_goal, ENTRY_ID, goal_id),
        true,
        {
            header: `Select ${customTermFilter('Tasks')}`,
            info: `Select or de-select ${customTermFilter('Tasks')} from list`,
            button_yes: 'Select',
            button_no: 'Cancel',
            empty: `There are no ${customTermFilter('Tasks')} in this ${customTermFilter('Goal')}.`,
            additional_buttons: [{
                text: `+ New ${customTermFilter('Task')}`,
                classes: 'btn btn-mm btn-green',
                result_code: 'create_task'
            }]
        },
        false,
        false,
        RETURN_OBJECT,
    );

    select_task_def.then(result => {
        if (result === 'create_task') {
            create_task(goal_id);
        } else {
            task_id_list_deferred.resolve(result);
        }

    }, cancel => {
        return task_id_list_deferred.reject();
    });
}

async function show_goals_list(for_user) {
    let POPUP_CONFIG = {
        header: `Select ${customTermFilter('Goal')}`,
        info: `Select or de-select ${customTermFilter('Goal')} from list`,
        button_yes: 'Select',
        button_no: 'Cancel',
        empty: `You do not have any ${customTermFilter('Goals')} to select`,
        additional_buttons: []
    };
    if (ALLOW_CREATE_GOAL) {
        POPUP_CONFIG.additional_buttons.push(
            {
                text: `+ New ${customTermFilter('Goal')}`,
                classes: 'btn btn-mm btn-green',
                result_code: 'create_goal'
            }
        );
    }
    POPUP_CONFIG['additional_filters'] = [{
        name: 'show_archived_goals',
        text: `Show hidden ${customTermFilter('Goals')}`,
        inputType: 'switch',
        filter: true,
        value: false,
        paramsWhenTrue: {
            show_archived_goals: true
        }
    }];

    let result;
    try {
        result = await selectFactory.endpoint_selector(
            _.partial(RESOURCE.get_users_goals_for_link, ENTRY_ID),
            false, POPUP_CONFIG);
    } catch (cancel) {
        task_id_list_deferred.reject();
        return;
    }

    if (result !== 'create_goal') {
        show_goals_tasks_lists(result); // goal id itself then
        return;
    }

    const gf = new GoalFactory();
    if (for_user) {
        gf.setForUserCreationForced(for_user);
    }
    try {
        const {goalData, wasCopied} = await gf.startGoalCreation();
        // a copied goal already has its tasks, so do not go straight into creating one
        show_goals_tasks_lists(goalData.id, !wasCopied);
        notifications.success(`${customTermFilter('Goal')} Created`);
    } catch (e) {
        if (e === GOAL_CREATION_CANCELLED) {
            show_goals_list(for_user); // back to the list the user came from
        } else {
            notifications.error(e || 'Error');
            task_id_list_deferred.reject(e);
        }
    }
}

/**
 * Picks a goal, then the tasks of that goal to link the entry to.
 * Either list can create a new goal\task and carry on with it.
 *
 * @return {Promise} resolves with the selected tasks, rejects if any of the lists is cancelled
 */
function link_to_goal(resource, id, allow_create_goal = false, for_user = undefined, return_object = false) {
    RESOURCE = resource;
    ENTRY_ID = id;
    ALLOW_CREATE_GOAL = allow_create_goal;
    RETURN_OBJECT = return_object;

    task_id_list_deferred = createDeferred();

    show_goals_list(for_user);

    return task_id_list_deferred.promise;
}

const linkToGoalFactory = {link_to_goal};

export {linkToGoalFactory};
